import type { PublicSiteIntegrationFlags } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import { isPublicSiteEnsoLine } from "@Front/Utils/publicSiteBranding";

/**
 * Enso : l'ancrage blockchain des documents validés reste actif (collecte GED).
 */
export function isEnsoDocumentAnchoringEnabled(): boolean {
	return isPublicSiteEnsoLine();
}

/** Enso : pas de chat IA dossier GED — Espace IA dans Backoffice cabinet. */
export function isEnsoFolderAiChatUiVisible(): boolean {
	return false;
}

/** Enso : pas d'envoi iNot (intégration notariale). */
export function isEnsoInotPushUiVisible(): boolean {
	return !isPublicSiteEnsoLine();
}

/** Enso : parcours Stripe / abonnement self-service si `sites.uses_stripe`. */
export function isEnsoStripeSubscriptionUiVisible(flags: PublicSiteIntegrationFlags): boolean {
	if (!isPublicSiteEnsoLine()) {
		return true;
	}
	return flags.uses_stripe;
}

export function publicFooterCopyrightLabel(): string {
	if (isPublicSiteEnsoLine()) {
		return "© Copyright Enso 2024";
	}
	return "© Copyright lecoffre 2024";
}
